/* eslint-disable no-restricted-imports */
/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React, { useMemo } from "react";
import { Link, useHistory } from "react-router-dom";
import Dropdown from "react-bootstrap/Dropdown";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import objectPath from "object-path";
import { useHtmlClassService } from "../../../_core/MetronicLayout";
import { toAbsoluteUrl } from "../../../../_helpers";
import { DropdownTopbarItemToggler } from "../../../../_partials/dropdowns";
import { Navigation } from "react-minimal-side-navigation";
import "react-minimal-side-navigation/lib/ReactMinimalSideNavigation.css";
import { actions } from "../../../../../app/modules/SearchPage/_redux/searchRedux";
import ReactLoading from "react-loading";
import Countdown from "react-countdown";
import {
  login,
  loginWithMobile,
  SignInWithMobile,
  VerifyLogin,
  VerifyRegister,
} from "../../../../../app/modules/Homepage/pages/widgets/components/cruds";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Slide,
  Tabs,
  Tab,
  InputAdornment,
} from "@material-ui/core";
import { Button, Radio, TextField, LinearProgress } from "@material-ui/core";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import {
  getTicketInvoice,
  buyTicket,
} from "../../../../../app/modules/SearchPage/_redux/searchCrud";
import { actions as authActions } from "../../../../../app/modules/Auth/_redux/authRedux";
import ReactCodeInput from "react-code-input";
import Person from "@material-ui/icons/Person";
import { useMediaQuery } from "react-responsive";
import { makeStyles } from "@material-ui/core/styles";
import AuthModal from "../../../../../app/modules/RUComponent/AuthModal";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export function UserProfileDropdown() {
  const propsz = {
    className: "class-Input ",
    inputStyle: {
      textAlign: "center",
      fontFamily: "sans",
      borderRadius: "6px",
      border: "1px solid lightgrey",
      boxShadow: "rgb(0 0 0 / 10%) 0px 0px 10px 0px",
      margin: "4px",
      paddingLeft: "8px",
      paddingRight: "0px",
      width: "10%",
      height: "42px",
      fontSize: "32px",
      boxSizing: "border-box",
      color: "black",
      backgroundColor: "white",
      direction: "ltr",
      flexGrow: 1,
    },
    touch: {
      border: "1px solid green",
    },
    inputStyleInvalid: {
      fontFamily: "monospace",
      margin: "4px",
      MozAppearance: "textfield",
      width: "15px",
      borderRadius: "3px",
      fontSize: "14px",
      height: "26px",
      paddingLeft: "7px",
      backgroundColor: "red",
      color: "red",
      border: "1px solid red",
    },
  };

  const isMobile = useMediaQuery({ query: `(max-width: 760px)` });

  // const { user } = useSelector((state) => state.auth);
  let { state: authState } = useSelector((state) => ({
    state: state.auth,
  }));

  const useStyles = makeStyles({
    barColorPrimary: {
      background: "red",
    },
  });

  const classes = useStyles();

  const SearchState = useSelector((state) => state.search);

  const [display, setDisplay] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const [value, setValue] = React.useState("");
  const [verifyTime, setVerifyTime] = React.useState(false);
  const [errMessage, setErrMessage] = React.useState(null);
  const [codeErrMessage, setCodeErrMessage] = React.useState(null);
  const [isLoading, setIsLoading] = React.useState(false);
  const [isLoginLoading, setIsLoginLoading] = React.useState(false);
  const [isPinLoading, setIsPinLoading] = React.useState(false);
  const [timeCounter, setTimeCounter] = React.useState(false);
  const [counterRemained, setCounterRemained] = React.useState(120000);

  const counterRenderer = ({ total }) => {
    setCounterRemained(total);
    const mainMin = 120000;
    const onePercent = mainMin / 100;
    const leftedPercent = total / onePercent;

    return (
      <LinearProgress
        variant="determinate"
        value={leftedPercent}
        dir="ltr"
        style={{ height: "0.7rem", borderRadius: "10px" }}
        className={` w-75 mx-auto`}
      />
    );
  };

  let { state } = useSelector(
    (state) => ({
      state: state.account,
    }),
    shallowEqual
  );

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setVerifyTime(false);
    setOpen(false);
  };

  const dispatch = useDispatch();
  const history = useHistory();
  // const passengersCount = history.location.pathname.split("/")[3].split(",");
  const splittedURL = history.location.pathname.split("/");
  const uiService = useHtmlClassService();
  const layoutProps = useMemo(() => {
    return {
      light:
        objectPath.get(uiService.config, "extras.user.dropdown.style") ===
        "light",
    };
  }, [uiService]);
  return (
    <div id="headerz-toggle">
      {!authState.user ? (
        <div className="d-none d-md-flex">
          <div className="d-none d-md-block"></div>
          <AuthModal modal={value} open={open} handleClose={handleClose} />
          <div className={"dropdown d-none d-md-flex"}>
            <div data-offset="10px,0px" className="topbar-item">
              <a
                // href={toAbsoluteUrl("/auth/login")}
                className={
                  "btn btn-icon btn-hover-transparent-white d-flex align-items-center btn-lg px-md-2 w-md-auto text-dark"
                }
                onClick={() => {
                  setValue("login");
                  handleClickOpen();
                }}
              >
                ورود
              </a>
            </div>
          </div>
          <div className={"dropdown"}>
            <div
              data-offset="10px,0px"
              className="topbar-item"
              onClick={() => {
                setValue("register");
                handleClickOpen();
              }}
            >
              <a
                // href={toAbsoluteUrl("/auth/registration")}
                className={
                  "btn btn-icon btn-hover-transparent-white d-flex align-items-center btn-lg px-md-2 w-md-auto text-dark"
                }
              >
                ثبت نام
              </a>
            </div>
          </div>
        </div>
      ) : (
        <div className="d-none d-md-block">
          <Dropdown drop="down" alignRight>
            <Dropdown.Toggle
              as={DropdownTopbarItemToggler}
              id="dropdown-toggle-user-profile"
            >
              <div
                className={
                  "btn btn-icon btn-hover-transparent-white d-flex align-items-center btn-lg px-md-2 w-md-auto"
                }
              >
                <span
                  className="text-dark opacity-90 font-weight-bolder font-size-base d-none d-md-inline mr-4 d-flex"
                  style={{ gap: "8px" }}
                >
                  {authState?.user?.user.firstName &&
                  authState?.user?.user.lastName
                    ? `${authState?.user?.user.firstName} ${authState?.user?.user.lastName}`
                    : "کاربر"}
                  <Person
                    style={{
                      color: "#6dd06d",
                      marginRight: "5px",
                      fontSize: "2.5rem",
                    }}
                  />
                </span>
                <span className="symbol symbol-35">
                  <span className="symbol-label text-white font-size-h5 font-weight-bold bg-white-o-30">
                    {/*{user !== undefined ? (user.firstName !== null?user.firstName[0]:'ک') : 'ک'}*/}
                    E
                  </span>
                </span>
              </div>
            </Dropdown.Toggle>
            <Dropdown.Menu className="dropdown-menu p-0 m-0 dropdown-menu-right dropdown-menu-anim-up dropdown-menu-lg p-0">
              <>
                {/** ClassName should be 'dropdown-menu p-0 m-0 dropdown-menu-right dropdown-menu-anim dropdown-menu-top-unround dropdown-menu-xl' */}
                {layoutProps.light && (
                  <>
                    <div className="d-flex align-items-center p-8 rounded-top">
                      <div className="symbol symbol-md bg-light-primary mr-3 flex-shrink-0">
                        <img
                          src={toAbsoluteUrl("/media/users/300_21.jpg")}
                          alt=""
                        />
                      </div>
                      <div className="text-dark m-0 flex-grow-1 mr-3 font-size-h5">
                        <Person
                          style={{
                            color: "#6dd06d",
                            marginLeft: "5px",
                            fontSize: "2.5rem",
                          }}
                        />

                        {authState?.user?.user.firstName &&
                        authState?.user?.user.lastName
                          ? `${authState?.user?.user.firstName} ${authState?.user?.user.lastName}`
                          : "کاربر"}
                        {/* {authState.user
                          ? (authState.user.user.firstName !== null
                              ? authState.user.user.firstName
                              : "کاربر جدید") +
                            " " +
                            (authState.user.user.lastName !== null
                              ? authState.user.user.lastName
                              : "")
                          : (authState.user.user.firstName !== null
                              ? authState.user.user.firstName
                              : "کاربر جدید") +
                            " " +
                            (authState.user.user.lastName !== null
                              ? authState.user.user.lastName
                              : "")} */}
                      </div>
                      {/* <span className="label label-light-success label-lg font-weight-bold label-inline">3 messages</span> */}
                    </div>
                    <div className="separator separator-solid"></div>
                  </>
                )}

                {!layoutProps.light && (
                  <div
                    className="d-flex align-items-center justify-content-between flex-wrap p-8 bgi-size-cover bgi-no-repeat rounded-top"
                    style={{
                      backgroundImage: `url(${toAbsoluteUrl(
                        "/media/misc/bg-1.jpg"
                      )})`,
                    }}
                  >
                    <div className="symbol bg-white-o-15 mr-3">
                      <span className="symbol-label text-success font-weight-bold font-size-h4">
                        S
                      </span>
                      {/*<img alt="Pic" className="hidden" src={user.pic} />*/}
                    </div>
                    <div className="text-white m-0 flex-grow-1 mr-3 font-size-h5">
                      سعید محمدی
                    </div>
                    {/* <span className="label label-success label-lg font-weight-bold label-inline">
                    3 messages
                  </span> */}
                  </div>
                )}
              </>

              <div className="navi navi-spacer-x-0 pt-5">
                <Link to="/account/profile">
                  <div className="navi-item px-8">
                    <div className="navi-link">
                      <div className="navi-icon mr-2">
                        <i className="flaticon2-calendar-3 text-success" />
                      </div>
                      <div className="navi-text">
                        <div className="font-weight-bold">حساب کاربری</div>
                        <div className="text-muted">
                          مدیریت اطلاعات{` `}
                          {/* <span className="label label-light-danger label-inline font-weight-bold">update</span> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </Link>

                <Link to="/account/travels">
                  {" "}
                  <div className="navi-item px-8">
                    <div className="navi-link">
                      <div className="navi-icon mr-2">
                        <i className="flaticon2-mail text-warning"></i>
                      </div>
                      <div className="navi-text">
                        <div className="font-weight-bold">سفرها</div>
                        <div className="text-muted">سفارش و استرداد</div>
                      </div>
                    </div>
                  </div>
                </Link>

                <Link to="/account/transaction">
                  <div className="navi-item px-8">
                    <div className="navi-link">
                      <div className="navi-icon mr-2">
                        <i className="flaticon2-rocket-1 text-danger"></i>
                      </div>
                      <div className="navi-text">
                        <div className="font-weight-bold">تراکنش های مالی</div>
                        <div className="text-muted">کلیه تراکنش ها</div>
                      </div>
                    </div>
                  </div>
                </Link>
                {/* <Link to="/account/recharge">
                  <div className="navi-item px-8">
                    <div className="navi-link">
                      <div className="navi-icon mr-2">
                        <i className="flaticon2-add text-primary"></i>
                      </div>
                      <div className="navi-text">
                        <div className="font-weight-bold">افزایش اعتبار</div>
                        <div className="text-muted">شارژ کیف پول</div>
                      </div>
                    </div>
                  </div>
                </Link> */}

                <div className="navi-separator mt-3"></div>

                <div className="navi-footer  px-8 py-5">
                  <a
                    href="#"
                    className="btn btn-clean font-weight-bold"
                    style={{ visibility: "hidden" }}
                  >
                    Upgrade Plan
                  </a>
                  <Link
                    onClick={() => {
                      dispatch(authActions.logout());
                      history.push("");
                    }}
                    className="btn btn-light-primary font-weight-bold"
                  >
                    خروج
                  </Link>
                </div>
              </div>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      )}
    </div>
  );
}
